// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Dxhpt","badges":"styles_badges__1vMAI"};